import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { SharedService } from './shared.service';
import { catchError, map } from 'rxjs/operators';
const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};


@Injectable({
    providedIn: 'root'
})
export class ApidocsService {

    constructor(private http: HttpClient, private sharedService: SharedService) { }

    getApidocs() {
        let apidocs$ = this.http.get<any>(this.sharedService.apiUrl('apidocs'))
        return apidocs$;
    }

    getApiDoc(key) {
        let apidocs$ = this.http.get<any>(this.sharedService.apiUrl('apidocs/'+key))
        return apidocs$;
    }
    getHomePage() {
        let apidocs$ = this.http.get<any>(this.sharedService.apiUrl('apidocs/home_page'))
        return apidocs$;
    }

  downloadManual(): Observable<Blob> {
    const httpOptionsPDF = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      responseType: 'blob' as 'json',
    };
    let process$ = this.http.get<any>(this.sharedService.apiUrl('apidocs/manual'), httpOptionsPDF).pipe(
      map((res: Response) => res), catchError(this.handleError<any>('download manual'))
    )
    return process$;

  }
    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }

    private log(message: string) {
        //this.messageService.add('HeroService: ' + message);
    }
}
